import React, { useState } from 'react'
import ReactTable from 'react-table'
import numeral from 'numeral'
import { Select } from 'antd'
import { useLocation, useHistory } from 'react-router-dom'

import Widget from '../Widget'
import withFetch from '../../../infrastructure/withFetch'
import Subtitle from '../../../components/Subtitle'
import Box from '../../../components/Box'

import { addToQuerystring, stringify } from '../../../utils/querystring'

const { Option } = Select

const buildQuery = (eventId, startDate, endDate, tags) => {
    const qs = stringify({ startDate, endDate, tags })
    return `/api/scans/get-scans-by-tag/${eventId}${qs ? '?' + qs : ''}`
}

const sum = arr => arr.reduce((acc, cur) => acc + cur, 0)

const buildColumns = tags => {
    const columns = tags.map(tag => ({
        id: tag,
        Header: tag,
        accessor: ((rows) => rows[`${tag}`]),
        Aggregated: _ => <span></span>,
        PivotValue: props => <span>{props.value}</span>,
    }))

    return [
        ...columns,
        {
            Header: 'Scans',
            accessor: 'Scans',
            aggregate: (values, _) => sum(values),
            Cell: props => <span>{numeral(props.value).format('0,0')}</span>,
        },
    ]
}

const buildPivotBy = tags => tags.slice(0, -1)

const Table = withFetch(
    props =>
        buildQuery(props.eventId, props.startDate, props.endDate, props.tags),
    ({ status, data, retry, tags }) => {
        const columns = buildColumns(tags)
        const pivotBy = buildPivotBy(tags)
        const anyResults = data.data && data.data.length !== 0

        return (
            <Widget data={data} status={status} retry={retry}>
                {anyResults && (
                    <>
                        <TagEditor
                            initialSelectedTags={tags}
                            allTags={data.tags}
                        />
                        <ReactTable
                            pivotBy={pivotBy}
                            data={data.data}
                            columns={columns}
                            minRows={0}
                            showPagination={false}
                            defaultPageSize={500}
                            defaultSorted={[{ id: 'Scans', desc: true }]}
                        />
                    </>
                )}

                {!anyResults && <div>No result(s)</div>}
            </Widget>
        )
    },
)

const TagEditor = ({ initialSelectedTags = [], allTags }) => {
    const location = useLocation()
    const history = useHistory()
    const [selectedTags, setSelectedTags] = useState(initialSelectedTags)

    const onTagsChange = () => {
        const newLocation = addToQuerystring(location, {
            tags: selectedTags,
        })

        history.push(newLocation)
    }

    return (
        <div className="flex ai-center" style={{ margin: '10px 0px' }}>
            <Select
                mode="multiple"
                style={{ width: '100%' }}
                value={selectedTags}
                onChange={tags => setSelectedTags(tags)}
                allowClear={true}
            >
                {(allTags || []).map(tag => (
                    <Option key={tag}>{tag}</Option>
                ))}
            </Select>
            <button
                className="btn btn-primary btn-sm"
                style={{ margin: '0 0 0 5px', boxShadow: '' }}
                onClick={onTagsChange}
            >
                Update
            </button>
        </div>
    )
}

const GetScansByTicketTypeWidget = ({ eventId, startDate, endDate, tags }) => {
    return (
        <div className="row">
            <div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-12">
                <div>
                    <Subtitle title="Scans by Tag" />
                    <Box>
                        <Table
                            startDate={startDate}
                            endDate={endDate}
                            tags={tags}
                            eventId={eventId}
                        />
                    </Box>
                </div>
            </div>
        </div>
    )
}
export default GetScansByTicketTypeWidget
